import axiosInstance from '../../../../common/axios.service';
import type {ADD_CHARGER_CATEGORY, UPDATE_CHARGER_CATEGORY} from './chargerCategory.type';
import type FILTERS from '../../../../common/filters.type';

const chargerCategoriesList = (values: FILTERS) => {
  return axiosInstance.get('chargercategory/', {params: values}).then((response) => {
    return response;
  });
};

const addChargerCategory = (values: ADD_CHARGER_CATEGORY) => {
  return axiosInstance.post('chargercategory/', values).then((response) => {
    return response;
  });
};

const updateChargerCategory = (values: {payload: UPDATE_CHARGER_CATEGORY; category_id: number}) => {
  return axiosInstance
    .put(`chargercategory/${values.category_id}`, values.payload)
    .then((response) => {
      return response;
    });
};

const chargerCategoryServices = {
  chargerCategoriesList,
  addChargerCategory,
  updateChargerCategory,
};

export default chargerCategoryServices;
